import { useNavigate } from "react-router-dom";
export function TopAppBarLogo() {
  const history = useNavigate();
  return (
    <img
      src={require("../assets/ekfc-logo-header.png")}
      alt="logo"
      style={{ height: "40px" }}
      onClick={() => history("/")}
    />
  );
}
